import { render } from "./HomeNewsModal.vue?vue&type=template&id=456ede0e&scoped=true"
import script from "./HomeNewsModal.vue?vue&type=script&lang=js"
export * from "./HomeNewsModal.vue?vue&type=script&lang=js"

import "./HomeNewsModal.vue?vue&type=style&index=0&id=456ede0e&lang=scss&scoped=true"
import "./HomeNewsModal.vue?vue&type=style&index=1&id=456ede0e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456ede0e"]])

export default __exports__